import { Country } from '@bigcommerce/checkout-sdk'
import { merge } from 'lodash'
import { CompanyBasicInfo } from './../../request/apis'
import { 
  SET_COMPANY_BASIC_INFO,
  SET_DEFAULT_SHIPPING_ADDRESS,
  SET_DEFAULT_BILLING_ADDRESS,
  SET_COUNTRIES,
  SET_ADDRESSES,
  SET_BASIC_ADDRESS_INFO,
} from '../actionTypes'

const defaultState = {
  companyBasicInfo: {} as CompanyBasicInfo,
  defaultShippingAddress: {},
  defaultBillingAddress: {},
  addresses: [],
  countries: [] as Country[],
  basicAddressInfo: {},
}

export default (state = defaultState, action: {type: string, payload: any}) => {
  switch (action.type) {
    case SET_COMPANY_BASIC_INFO: return {...state, companyBasicInfo: action.payload}
    case SET_DEFAULT_SHIPPING_ADDRESS: return {...state, defaultShippingAddress: merge({}, state.basicAddressInfo, action.payload)}
    case SET_DEFAULT_BILLING_ADDRESS: return {...state, defaultBillingAddress: merge({}, state.basicAddressInfo, action.payload)}
    case SET_ADDRESSES: return {...state, addresses: action.payload}
    case SET_COUNTRIES: return {...state, countries: action.payload}
    case SET_BASIC_ADDRESS_INFO: return {...state, basicAddressInfo: action.payload}
    default: return state
  }
}
